module.exports = __webpack_public_path__ + "static/visual_4-7a35c5eef6fa419a9be7fa8efb35c142.jpg";